import { render } from "./Header.vue?vue&type=template&id=0727ad8f"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=0727ad8f&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__